(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-recommendations-grid"] && !Shopify.designMode) return;
  try {
    
  function initProductRecommendationsSwiper() {
    const productRecommendationsSwiper = new Moonbase.Swiper('.product-recommendations-swiper', {
      loop: true,
      slidesPerView: 1.7,
      spaceBetween: 1,
      navigation: {
        nextEl: '.product-recommendations-swiper-button-next',
        prevEl: '.product-recommendations-swiper-button-prev',
        clickable: true,
      }
    });
  }

  function getProductRecommendations(section) {
    const url = section.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations-section');

        if (recommendations && recommendations.innerHTML.trim().length) {
          section.innerHTML = recommendations.innerHTML;
          initProductRecommendationsSwiper();
          section.classList.remove('hidden');
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    const productRecommendationsSections = document.querySelectorAll('.product-recommendations-section');
    productRecommendationsSections.forEach((section) => {
      getProductRecommendations(section);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
